module.exports = __webpack_public_path__ + "assets/img/cap.5213215d.png";